const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) || "";

export interface ProjectFacet {
  id: string;
  title: string;
  summary: string;
  quadrant: string;
  root: boolean;
  domain: string;
  urgency: number;
  importance: number;
}

export interface ProjectSnapshot {
  version: number;
  agent_leg: string;
  facets: ProjectFacet[];
  timestamp: string;
}

export interface Project {
  id: string;
  user_id: string;
  title: string;
  snapshots: ProjectSnapshot[];
  created_at: string;
  updated_at: string;
}

async function request<T>(path: string, init: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...(init.headers ?? {}) },
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json() as Promise<T>;
}

export async function createProject(
  title: string,
  authHeader: Record<string, string>,
): Promise<Project> {
  return request<Project>("/api/crucible/project", {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({ title }),
  });
}

export async function getProject(
  projectId: string,
  authHeader: Record<string, string>,
): Promise<Project | null> {
  const res = await fetch(`${API_BASE}/api/crucible/project/${projectId}`, {
    headers: { "Content-Type": "application/json", ...authHeader },
  });
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json() as Promise<Project>;
}

export async function listProjects(
  authHeader: Record<string, string>,
): Promise<Project[]> {
  return request<Project[]>("/api/crucible/projects", {
    method: "GET",
    headers: authHeader,
  });
}

export async function saveSnapshot(
  projectId: string,
  facets: ProjectFacet[],
  agentLeg: string,
  authHeader: Record<string, string>,
): Promise<Project> {
  return request<Project>(`/api/crucible/project/${projectId}/snapshot`, {
    method: "POST",
    headers: authHeader,
    body: JSON.stringify({ facets, agent_leg: agentLeg }),
  });
}
